import styled from 'styled-components';
import { Dropdown } from 'react-bootstrap';

const AdvertisersDropdownButton = styled(Dropdown.Toggle)`
  border: 1px solid #b5b5b5;
  width: 100%;
`;

export default AdvertisersDropdownButton;
